var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "save_svg__\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "save_svg__\\u72B6\\u6001\\u680F\\u4E0D\\u540C\\u6837\\u5F0F",
    transform: "translate(-677.000000, -8.000000)",
    stroke: "#5A5A5A",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "save_svg__\\u4FDD\\u5B58",
    transform: "translate(650.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "save_svg__save",
    transform: "translate(27.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "save_svg__\\u77E9\\u5F62",
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "save_svg__\\u8DEF\\u5F84-4",
    strokeLinejoin: "round",
    points: "5.05785378 1.5 5.05785378 9.5 15.5207928 9.5 15.5207928 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 3.5,
    x2: 12.5,
    y2: 6.25,
    id: "save_svg__\\u8DEF\\u5F84-6",
    strokeLinecap: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.730ab694.svg";
export { ForwardRef as ReactComponent };